/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Styles from './Renegociacao25EmpNegocie.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function Renegociacao25EmpNegocie() {
  return (
    <>
      <section id="renegociacao25-emp-entenda">
        <ContainerHome24>
          <div className="entenda-conteudo">
            <img src="assets/renegociacao25-emp/img-negocie.svg" alt="" />
            <div className="entenda-textos">
              <h2 className="entenda-titulo">Negocie seu empréstimo com garantia</h2>
              <p className="entenda-texto">
                Na Santander Financiamentos você pode renegociar o seu contrato atrasado ou
                reorganizar seu contrato em dia para facilitar a sua vida e de sua família.
              </p>
            </div>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default Renegociacao25EmpNegocie;
